import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import {CommonService} from '../../../app/common.service';

@Component({
  selector: 'component-questionnaire-tag',
  templateUrl: './component.questionnaire-tag.html',
  styleUrls: ['./component.questionnaire-tag.css']
})

export class ComponentQuestionnaireTag implements OnInit, AfterViewInit, OnChanges {
  @Input() questionnaireTagArray: any; //问卷标签
  @Input() questionnaireContext: string; //富文本内容
  @Output() outPutSelectedTag = new EventEmitter<any>(); //回传标签

  selectedTag: string = ""; //用户选择的标签

  constructor(private el: ElementRef,
              private commonService: CommonService,
              private renderer: Renderer2) {}

  ngOnInit() {

  }

  ngAfterViewInit(){

  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.questionnaireContext && changes.questionnaireContext.currentValue !==''){
      this.commonService.setStorage('inputContext',this.questionnaireContext);
    }
  }

  // 选择标签
  selectTag(i){
    let inputContext = this.commonService.getStorage('inputContext') ? this.commonService.getStorage('inputContext'): '';

    console.log(inputContext);
    let target = this.el.nativeElement.querySelector('.elem-'+i);
    if(target.classList.contains('active') == true){
      this.renderer.removeClass(target, 'active');
      // this.selectedTagArray.splice(this.selectedTagArray.findIndex(item => item === this.questionnaireTagArray[i].description),1);
      // this.selectedTag = this.inputContext.replace(this.questionnaireTagArray[i].description+',', '');
      this.selectedTag = inputContext.replace(this.questionnaireTagArray[i].description+',', '');
      console.log( this.selectedTag);
      this.commonService.setStorage('inputContext',this.selectedTag);
    }else{
      if(inputContext.length >= 300){
        return false;
      }else{
        this.renderer.addClass(target, 'active');
        this.selectedTag = inputContext + this.questionnaireTagArray[i].description+',';
        // this.selectedTag += this.questionnaireTagArray[i].description+',';
      }
    }
    this.outPutSelectedTag.emit(this.selectedTag);
  }


}



// WEBPACK FOOTER //
// ./src/component/questionnire/child-tag/component.questionnaire-tag.ts